export default __webpack_public_path__ + "static/media/researchBM.c6eebf14.png";